import { useEffect } from 'preact/hooks';
import {
  useCreditsStore,
  selectTopupSuccessNoticePending,
  selectTopupSuccessCredits,
} from '../state/creditsStore';

// ════════════════════════════════════════════════════════════════════════════
// TopupSuccessNotice — pure renderer of the topup-success crossing (E2 tail b, PR B).
// TOAST style. Fires ONCE per server-authoritative topup fact behind the TWO gates
// (a persisted pending-topup marker + a server topup attribution — the store ticks
// topupSuccessCrossings only when BOTH hold; NEVER on a balance diff, a cancelled
// checkout, a grant, or a refund). It is a clone of LowBalanceNotice, but a SEPARATE
// renderer with DISTINCT copy — the subscription-activated path (useChatShell) is
// untouched. ~5s auto-dismiss; dismiss records the crossing seen (acknowledgeTopupSuccess).
// ════════════════════════════════════════════════════════════════════════════

/** Auto-dismiss delay (ms). A success confirmation is a transient nicety, not a demand. */
const AUTO_DISMISS_MS = 5000;

export function TopupSuccessNotice() {
  const pending = useCreditsStore(selectTopupSuccessNoticePending);
  const credits = useCreditsStore(selectTopupSuccessCredits);
  const acknowledge = useCreditsStore((s) => s.acknowledgeTopupSuccess);

  useEffect(() => {
    if (!pending) return;
    const t = setTimeout(acknowledge, AUTO_DISMISS_MS);
    return () => clearTimeout(t);
  }, [pending, acknowledge]);

  if (!pending) return null;

  return (
    <div class="topup-success-notice" role="status" aria-live="polite">
      <span class="topup-success-notice__text">
        ✓ {credits} credits added — you're topped up
      </span>
      <button
        class="topup-success-notice__dismiss"
        type="button"
        aria-label="Dismiss"
        onClick={acknowledge}
      >
        ×
      </button>
    </div>
  );
}
